"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _colors = require("HubStyleTokens/colors");

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _ChangesList = _interopRequireDefault(require("lead-flows-ui/components/common/ChangesList"));

var _DeleteUnpublishedLink = _interopRequireDefault(require("./DeleteUnpublishedLink"));

var _DynoUtils = require("lead-flows-ui/utils/DynoUtils");

var SavedMessage =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SavedMessage, _PureComponent);

  function SavedMessage() {
    (0, _classCallCheck2.default)(this, SavedMessage);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SavedMessage).apply(this, arguments));
  }

  (0, _createClass2.default)(SavedMessage, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.secondaryNavigation." + suffix;
    }
  }, {
    key: "getUnsavedLangKey",
    value: function getUnsavedLangKey(suffix) {
      var dyno = this.props.dyno;
      var primaryCTA = (0, _DynoUtils.getDynoPrimaryCTA)(dyno);
      var prefix = primaryCTA === 'schedule' ? 'schedule' : 'publish';
      return this.langKey("save." + prefix + "." + suffix);
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
          dyno = _this$props.dyno,
          onDeleteDraft = _this$props.onDeleteDraft;
      var primaryCTA = (0, _DynoUtils.getDynoPrimaryCTA)(dyno);

      var button = _I18n.default.text(this.langKey(primaryCTA));

      return _react.default.createElement("div", {
        className: "saved-message__body"
      }, _react.default.createElement("p", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: this.langKey('save.savedChanges'),
        options: {
          button: button
        }
      })), _react.default.createElement(_ChangesList.default, {
        changes: dyno.changes
      }), _react.default.createElement("div", {
        className: "m-top-3"
      }, _react.default.createElement(_DeleteUnpublishedLink.default, {
        labelLangKey: this.getUnsavedLangKey('delete'),
        onClick: onDeleteDraft
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var dyno = this.props.dyno;
      var isLoading = dyno.draft && !dyno.changes;
      return _react.default.createElement("span", {
        className: "secondary-navigation-saving__auto-save m-right-3"
      }, _react.default.createElement(_UIIcon.default, {
        color: _colors.OZ,
        name: "success"
      }), _react.default.createElement("span", {
        className: "secondary-navigation-saving__auto-saved m-left-2"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('save.autosave')
      })), _react.default.createElement("span", {
        className: "m-left-1"
      }, _react.default.createElement(_UIDropdown.default, {
        buttonText: _react.default.createElement(_FormattedMessage.default, {
          message: this.getUnsavedLangKey('label')
        }),
        buttonUse: "link-on-dark",
        className: "secondary-navigation-saving__auto-saved__dropdown m-x-5 m-y-3"
      }, _react.default.createElement("div", null, isLoading ? _react.default.createElement(_UILoadingSpinner.default, null) : this.renderContent()))));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        dyno: _react.PropTypes.object.isRequired,
        onDeleteDraft: _react.PropTypes.func.isRequired
      };
    }
  }]);
  return SavedMessage;
}(_react.PureComponent);

exports.default = SavedMessage;
module.exports = exports.default;